function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { range } from 'lodash-es';
import pluralize from 'pluralize';
import { GridItem, WithInfoIcon, Checkbox, Typography, Select, MenuItem, useDevice } from 'seagull';
import styles from "./ExpirationDate.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const dayOptions = () => range(1, 91);
const pluralizeDay = day => pluralize('day', day, true);
const noneOption = {
  value: '-1',
  label: 'Not set'
};
const ExpirationDate = _ref => {
  let {
    daysToExpiration,
    hasExpirationDate,
    disabled,
    setDaysToExpiration,
    setHasExpirationDate
  } = _ref;
  const {
    isMobileDevice
  } = useDevice();
  const commonSelectProps = {
    collapseHelperText: false,
    size: 'small',
    width: 70,
    disabled,
    value: daysToExpiration,
    menuMaxHeight: 400,
    testId: 'expiration-days-select'
  };
  const commonMenuItemProps = day => ({
    testId: "expiration-days-select-item-".concat(day),
    key: day,
    value: day.toString(),
    selected: daysToExpiration === day
  });
  const content = isMobileDevice ? /*#__PURE__*/_jsxs(Select, _objectSpread(_objectSpread({}, commonSelectProps), {}, {
    isSelected: (itemValue, currentValue) => +itemValue === +currentValue,
    label: "Proposal expiration",
    displayValue: hasExpirationDate ? "".concat(pluralizeDay(daysToExpiration), " after sending") : noneOption.label,
    value: hasExpirationDate ? daysToExpiration.toString() : noneOption.value,
    onChange: e => {
      if (e.target.value === noneOption.value) {
        setHasExpirationDate(false);
        setDaysToExpiration(+noneOption.value);
      } else {
        setHasExpirationDate(true);
        setDaysToExpiration(+e.target.value);
      }
    },
    children: [/*#__PURE__*/_jsx(MenuItem, {
      value: noneOption.value,
      selected: !hasExpirationDate,
      testId: "expiration-days-select-item-none",
      children: noneOption.label
    }), dayOptions().map(day => /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({}, commonMenuItemProps(day)), {}, {
      children: pluralizeDay(day)
    })))]
  })) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(WithInfoIcon, {
      info: "Set the number of days after which the proposal will expire. After the expiration date your client will not be able to sign or access the proposal.",
      infoTestId: "expiration-date-tooltip",
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: hasExpirationDate,
        disabled: disabled,
        onChange: e => setHasExpirationDate(e.target.checked),
        testId: "expiration-date-checkbox",
        children: /*#__PURE__*/_jsx(Typography, {
          children: "Set an expiration for this proposal"
        })
      })
    }), hasExpirationDate && /*#__PURE__*/_jsxs(Typography, {
      className: styles.days,
      children: ["The proposal expires", /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, commonSelectProps), {}, {
        onChange: e => setDaysToExpiration(+e.target.value),
        children: dayOptions().map(day => /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({}, commonMenuItemProps(day)), {}, {
          children: day
        })))
      })), "days after sending"]
    })]
  });
  return /*#__PURE__*/_jsx(GridItem, {
    span: 12,
    testId: "expiration-date",
    children: content
  });
};
export default ExpirationDate;